import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FlowerField from "../../../assets/images/flower_field.jpg";
import BookCover from "../../../assets/images/flora_of_the_chigao_region_cover.png";

const BookSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundImage: `url(${FlowerField})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: {
          xs: "36px",
          md: "74px",
        },
        paddingBottom: {
          xs: "36px",
          md: "74px",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.primary.main,
          opacity: 0.8,
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          zIndex: 2,
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          paddingLeft: {
            xs: "24px",
            md: 0,
          },
          paddingRight: {
            xs: "24px",
            md: 0,
          },
        }}
      >
        <img
          src={BookCover}
          alt="Flora of the Chicago Region"
          style={{
            width: "auto",
            height: "475px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: {
              xs: 0,
              md: "50px",
            },
          }}
        >
          <Typography
            color="white"
            sx={{
              fontSize: "36px",
              fontWeight: 400,
              lineHeight: 1.1,
              paddingTop: {
                xs: "24px",
                md: 0,
              },
            }}
          >
            Flora of the Chicago Region
          </Typography>

          <Typography
            color="white"
            sx={{
              fontSize: "20px",
              fontWeight: 300,
            }}
          >
            by Gerould Wilhelm and Laura Rericha
          </Typography>

          <Typography
            color="white"
            variant="body2"
            sx={{
              marginTop: {
                xs: "12px",
                md: "24px",
              },
              marginBottom: {
                xs: "24px",
                md: "50px",
              },
            }}
          >
            After 15 years and close to 100,000 hours of work, the book was
            published in 2017 by the Indiana Academy of Sciences under the
            direction of Bill McKnight. Having thoroughly researched, detailed,
            and extensively illustrated the book, we hope it is everything you
            need to understand, love, and help care for our region.
          </Typography>

          {/* <Button
            variant="contained"
            color="secondary"
            sx={{
              width: "200px",
              paddingTop: "10px",
              paddingBottom: "10px",
              alignSelf: {
                xs: "center",
                md: "start",
              },
            }}
          >
            Show More
          </Button> */}
        </Box>
      </Box>
    </Box>
  );
};

export default BookSection;
